import { render } from "./VistaProhibida.vue?vue&type=template&id=0c91d539&scoped=true"
const script = {}

import "./VistaProhibida.vue?vue&type=style&index=0&id=0c91d539&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c91d539"]])

export default __exports__